import React, { Fragment, useContext } from 'react';
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react';
import { Helmet } from 'react-helmet'

import Admin from '../../dropdowns/Admin';
import { SiteContext } from '../../../context/SiteContext';

// TEMP V9 HERE
// const vers = 9;
// const versionNo = 9.011; // 8.4383
// const emxLogo = 'https://wayfindit.s3-us-west-2.amazonaws.com/styles/emx-logo.png'; // or emx-logo-white.png
// const wayfinditLogo = 'https://wayfindit.s3-us-west-2.amazonaws.com/styles/wayfindit-logo.png'; // or wayfindit-logo-white.png

const vers = 8;
const versionNo = 8.45;
const emxLogo = 'https://wayfindit.s3-us-west-2.amazonaws.com/styles/emx-logo-white.png';
const wayfinditLogo = 'https://wayfindit.s3-us-west-2.amazonaws.com/styles/wayfindit-logo-white.png';

const View = () => {
  const navigate = useNavigate();
  const { hostname } = useContext(SiteContext);
  const { user, logout, isAuthenticated, loginWithRedirect } = useAuth0();

  return (
    <Fragment>
      <Helmet>
        <style>{` body { padding-top:4rem; } `}</style>
      </Helmet>
      {/* <nav className="navbar navbar-expand-md navbar-dark bg-dark fixed-top"> */}
      <nav className={`navbar navbar-expand-md fixed-top ${vers === 9 ? 'navbar-light' : 'navbar-dark bg-dark'}`}>
        <div className="container-fluid">
          <div className="navbar-brand me-0">
            { (hostname.includes('modulex') || hostname.includes('emx')) && (
              <img src={emxLogo} className="pointer" alt="EMX"  onClick={() => navigate('/')} />
            )}
            { !hostname.includes('modulex') && !hostname.includes('emx') && (
              <img src={wayfinditLogo} className="pointer" alt="Wayfindit"  onClick={() => navigate('/')} />
            )}
          </div>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0">
              { isAuthenticated && (
                <Fragment>
                  <li className="nav-item dropdown ms-2">
                    <span className="nav-link dropdown-toggle pointer" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img alt={user?.name} src={user?.picture} className="avatar" />
                    </span>
                    <ul className="dropdown-menu dropdown-menu-md-end" aria-labelledby="navbarDropdown">
                      <Admin />
                      <li className="pointer dropdown-item" onClick={() => {
                        logout({ returnTo: window.location.origin })
                      }}>Logout</li>
                      <li><hr className="dropdown-divider" /></li>
                      <li><p className="dropdown-item small mb-0 text-muted">Version {versionNo}</p></li>
                    </ul>
                  </li>
                </Fragment>
              )}

              { !isAuthenticated && (
                <li className="nav-item ms-2 pointer" onClick={loginWithRedirect}>
                  <span className="nav-link">Login</span>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </Fragment>
  )
}

export default View;
